import React from "react";
const BoltIcon = () => {
  return <svg className="w-6 h-6 mr-1 text-green-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-sentry-element="svg" data-sentry-component="BoltIcon" data-sentry-source-file="BoltIcon.tsx">
      <path fill="none" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="BoltIcon.tsx" />
      <path fill="currentColor" d="M13 10h7l-9 13v-9H4l9-13z" data-sentry-element="path" data-sentry-source-file="BoltIcon.tsx" />
    </svg>;
};
export default BoltIcon;